import LayoutWithCalcAndSideImgs from '../components/Redesign/LayoutWithCalcAndSideImgs/LayoutWithCalcAndSideImgs'
import ForumPostList from '../components/ForumPostList'

const LigeIIzazovi = () => {
  return (
    <LayoutWithCalcAndSideImgs title='LIGE I IZAZOVI'>
      <ForumPostList
        postUrl='/getAllBetPortalPosts?type=leagues'
        type='leagues'
      />
    </LayoutWithCalcAndSideImgs>
  )
}

export default LigeIIzazovi
